import {
    LOCAL_APP_VERSION,
    LOCAL_BRANCH_NAME,
    LOCAL_STORAGE_PAYPAL_DATA,
    LOCAL_STORAGE_TRACK_DATA
} from "../constants/LocalStorage";
import {
    getAccountType,
    getLastOrderId,
    getUserId,
    getUserPrivacyPreferences,
    isAuth, isInHub, shouldViewUpgrade
} from "./AppHelper";
import {APP_HASH_PATH, CHECKOUT_PAGE_TYPE, POST_MESSAGES, WEVIDEO_PLANS} from "../constants/AppGlobal";
import LocalStorageHelper from "./LocalStorageHelper";
import Bowser from "bowser";
import {getTierByProductCode} from "./PlansHelper";
import URLHelper from "./URLHelper";

export const getURLParameters = (url) => {
    let result={};

    if(typeof url === "undefined" || (url.indexOf("?") === -1 && url.indexOf("http") !== -1)){
        return result;
    }

    let params = url.substring(1 + url.indexOf('?')),
        vars = params.split("&");

    for ( let i = 0; i < vars.length; i++) {
        if (vars[i].indexOf("=") > -1) {
            let pair = [vars[i].substr(0, vars[i].indexOf("=")), vars[i].substr(1 + vars[i].indexOf("="))];
            result[pair[0]] = pair[1];
        }
    }

    return result;
};

export const getEnv = () => {
    return process.env.NODE_ENV;
};

export const getURLParameter = (name, stripSlashAtEnd) => {
    if (typeof stripSlashAtEnd === "undefined") {
        stripSlashAtEnd = false;
    }

    let params = getURLParameters(window.location.toString()),
        key;

    for (key in params) {
        if (key === name && params.hasOwnProperty(key)) {
            let result = params[key];
            if (result.indexOf('#') > 0) {
                result = result.substr(0, result.indexOf('#'));
            }

            if (stripSlashAtEnd && result.length > 0 && result.substr(result.length - 1) === "/") {
                result = result.substr(0, result.length - 1);
            }

            return result;
        }
    }

    return "";
};

/* istanbul ignore next */
export const getAppVersionNumber = () => {
    let appVersion = localStorage.getItem(LOCAL_APP_VERSION);
    /* istanbul ignore else */
    if (appVersion === null) {
        const scripts = document.getElementsByTagName('script');
        for (let i = 0; i < scripts.length; i++) {
            let src = scripts[i].getAttribute('src');
            if (src && src.indexOf("devx/new-checkout") > 0) {
                src = src.substr(src.indexOf("devx/new-checkout") + 5, src.length - 1);
                src = src.substr(src.indexOf("/") + 1, src.length - 1);
                appVersion = src.substr(0, src.indexOf("/"));
            } else if (src && src.indexOf("branch") > 0) {
                src = src.substr(src.indexOf("branch") + 7, src.length - 1);
                src = src.substr(src.indexOf("/") + 1, src.length - 1);
                appVersion = src.substr(0, src.indexOf("/"));
            } else {
                appVersion =  "-1";
            }
        }

        const appScript = document.getElementById("appSrc");
        if(appScript != null){
        	const dataVersion = appScript.getAttribute('data-version');

        	if(dataVersion !== null) {
               appVersion = dataVersion;
        	}
        }
     

        localStorage.setItem(LOCAL_APP_VERSION, appVersion);
    }

    return appVersion;
};

export const getEnvironmentMode = () => {
    const prod =
        window.location.href.indexOf("www.wevideo") > 0 ||
        window.location.href.indexOf("//wevideo.com") > 0 ||
        window.location.href.indexOf("dualstack.tmp-prod-lb") > 0;

    return prod ? "prod" : "test";
};

export const isProduction = () => {
    return getEnvironmentMode() === "prod"
};

export const getLocalSetting = (key, defaultVal) => {
    let val = localStorage.getItem(key + "_" + getUserId());

    if (val == null && window.hasOwnProperty('instanceInfo')){
        val = window.instanceInfo.hasOwnProperty(key) ? window.instanceInfo[key] : null;
    }

    return (val === null || typeof val === "undefined") ? defaultVal : val;
};

export const setLocalSetting = (key, val) => {
    if(isAuth()) {
        localStorage.setItem(key + "_" + getUserId(), val);
    }
};

export const getUserPrivacySettingsArray = (stateSettings) => {
    let userSettings = getUserPrivacyPreferences();
    let returnArray = [];

    userSettings.forEach(function(element, index) {
        if (typeof stateSettings[element.key] !== 'undefined') {
            let tmp = {};
            tmp['id'] = element.id;
            tmp['value'] = stateSettings[element.key];
            returnArray.push(tmp);
        }
    });

    return returnArray;
};


export const getFacebookAppId = () => {
    if (window.location.hostname === "localhost") {
        return "1516219188416536";
    } else if (isProduction()) {
        return "527449224089666";
    } else {
        return "854711451303764";
    }
};

export const getTagManagerArgs = () => {
    if(window.location.hostname === "www.wevideo.com") {
        return {
            gtmId: "GTM-MRL78F",
            dataLayer: []
        }
    }

    return {
        gtmId: "GTM-MRL78F",
        dataLayer: [],
        auth: "VDhhelbI-O2jSRjNLwyLdw",
        preview: "env-71"
    }
};

export const roundToTwoDecimals = (num) => {
    let numStr = num.toString();
    if (numStr.includes('.')) {
        let arrSplit = numStr.split('.');
        numStr = arrSplit[0] + '.';
        if (arrSplit[1].length === 0) {
            numStr = numStr + '00';
        } else if (arrSplit[1].length === 1) {
            numStr = numStr + arrSplit[1] + '0';
        } else {
            numStr = numStr + arrSplit[1].substring(0, 2);
        }
    } else {
        if (num !== 0) {
            numStr = numStr + '.00';
        } else {
            return num;
        }
    }

    return numStr;
};

export const formatPriceToFixed = (price, fractionDigits = 2) => {
    const x = price.toFixed(fractionDigits);
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const isObjectEmpty = (obj) => {
    let key;
    for(key in obj) {
        if(typeof obj.hasOwnProperty !== "undefined" && obj.hasOwnProperty(key)) {
            return false
        } else if(Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
};

export const isLocalHost = () => {
    return window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
};

export const getUrlExtension = (url) => {
    // eslint-disable-next-line no-useless-escape
    return url.split(/[#?]/)[0].split('.').pop().trim();
};

export const loadedInIframe = () => {
    try {
        if (isLocalHost()) {
            // on localhost we want it differently because hosts are different on hub and cart
            return window.self !== window.top;
        }
        if (window.self !== window.parent && parentIsSameOrigin()) {
            return window.parent.hasOwnProperty('UserSession');
        } else {
            return false;
        }
    } catch (e) {
        /* istanbul ignore next */
        return true;
    }
};

export const parentIsSameOrigin = () => {
    try {
        return window.parent.location.host === window.location.host;
    } catch (e) {
        return false;
    }
};

export const  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const sendPostMessage = (message) => {
	/* We expect to get an object. Create one if we just receive a value */
	if(typeof message !== "object"){
		message = {
			event: message	
		};
	}
	
    console.log('TRYING TO SEND POST MESSAGE:..', message);
    if (loadedInIframe() === true) {
    	let destination = process.env.REACT_APP_HUB_URL || window.location.origin;
        let parentWindow = window.parent;

        /* istanbul ignore else */
    	if(typeof process.env.REACT_APP_HUB_URL === "undefined"){
    		/* We're not running locally, with the hub on another port */
    		if (window.location.origin !== parentWindow.location.origin) {
    			return false;
    	    }
    	}
      
        let exists = false;
        Object.keys(POST_MESSAGES).forEach(function(key) {
            if (POST_MESSAGES[key] === message.event) {
                exists = true;
            }
        });
        if (exists === true) {
            parentWindow.postMessage(JSON.stringify(message), destination);
            console.log('POST MESSAGE SENT to ' + destination);
            return true;
        }
    }
    return false;
};

export const sendUrlChangedPostMessage = (location) => {
    if (loadedInIframe() === true) {
        let message = {
            event: POST_MESSAGES.CHECKOUT_NAVIGATION,
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        };
        sendPostMessage(message);
    }
};

export const contains = (innerString, outerString) => {
    return outerString.indexOf(innerString) >= 0;
};

export const deviceName = (user_agent) => {
    if(contains("Android", user_agent) ||
        contains("webOS", user_agent) ||
        contains("iPhone", user_agent) ||
        contains("iPad", user_agent) ||
        contains("iPod", user_agent) ||
        contains("BlackBerry", user_agent) ||
        contains("Windows Phone", user_agent)) {
        return "Mobile";
    }

    return "Web";
};

export const trackPageValue = () => {
    return loadedInIframe() === true ? "upgrade_plans" : "website_plans";
};

export const getLocationFormLocalStorageTrack = () => {
    const locationTrackStore = LocalStorageHelper.get(LOCAL_STORAGE_TRACK_DATA);
    let locationTrack = "locationNotSet";

    /* istanbul ignore else */
    if(
        typeof locationTrackStore !== "undefined"
        && locationTrackStore !== null
        && !isObjectEmpty(locationTrackStore)
        && locationTrackStore.hasOwnProperty("location")
        && locationTrackStore.location !== ""
    ) {
        locationTrack = locationTrackStore.location;
        LocalStorageHelper.update(LOCAL_STORAGE_TRACK_DATA, "location", "");
    }

    return locationTrack;
};

export const isHTMLEditorSupported = (browser) => {
    if (
        window.chrome !== null &&
        window.chrome !== undefined &&
        window.navigator.vendor === "Google Inc."
    ) {
        return true;
    }

    if (
        (window.hasOwnProperty('opr') && !!window.opr && window.opr.hasOwnProperty('addons') &&  !!window.opr.addons) ||
        !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0
    ) {
        return true;
    }

    if (typeof InstallTrigger !== "undefined") {
        //Firefox
        return true;
    }

    if (browser.msedge && (browser.version >= 14.14393 || window.WinRT)) {
        return true;
    }

    return false;
}

export const isUnsupportedBrowserVersion = () => {
    const browser = Bowser;

    switch (browser.name) {
        case "Chrome":
            return browser.version < 40;
        case "Firefox":
            return browser.version < 40;
        case "Opera":
            return browser.version < 40;
        default:
            return !isHTMLEditorSupported(browser);
    }
};
export const isFromReferAFriend = () => {
    return window.hasOwnProperty("isFromReferAFriend") && window.isFromReferAFriend === true
};

export const setPaypalCheckoutData = (totalAmount, productCode, productName, tier, isCCRequiredTrial, planIsTrial) => {
    const paypalData = {
        totalAmount: totalAmount,
        productCode: productCode,
        productName: productName,
        tier: tier,
        hasPaypalPayment: true,
        isCCRequiredTrial: isCCRequiredTrial,
        planIsTrial: planIsTrial,
    };

    sessionStorage.setItem(LOCAL_STORAGE_PAYPAL_DATA, JSON.stringify(paypalData));
};

export const getPaypalCheckoutData = () => {
    let paypalData = sessionStorage.getItem(LOCAL_STORAGE_PAYPAL_DATA);
    /* istanbul ignore else */
    if (paypalData !== null) {
        paypalData = JSON.parse(paypalData);
    }
    let productCode = WEVIDEO_PLANS.FREE_PLAN, totalAmount = 0, hasPaypalPayment = false, isCCRequiredTrial = false, planIsTrial = false;
    let tier = getTierByProductCode(productCode), productName = getAccountType();

    /* istanbul ignore else */
    if (typeof paypalData !== 'undefined' && paypalData !== null) {
        /* istanbul ignore else */
        if (paypalData.hasOwnProperty('totalAmount')) {
            totalAmount = paypalData.totalAmount;
        }
        /* istanbul ignore else */
        if (paypalData.hasOwnProperty('productCode')) {
            productCode = paypalData.productCode;
        }
        /* istanbul ignore else */
        if (paypalData.hasOwnProperty('productName')) {
            productName = paypalData.productName;
        }
        /* istanbul ignore else */
        if (paypalData.hasOwnProperty('tier')) {
            tier = paypalData.tier;
        }
        /* istanbul ignore else */
        if (paypalData.hasOwnProperty('hasPaypalPayment')) {
            hasPaypalPayment = paypalData.hasPaypalPayment;
        }
        /* istanbul ignore else */
        if (paypalData.hasOwnProperty('isCCRequiredTrial')) {
            isCCRequiredTrial = paypalData.isCCRequiredTrial;
        }
        /* istanbul ignore else */
        if (paypalData.hasOwnProperty('planIsTrial')) {
            planIsTrial = paypalData.planIsTrial;
        }
    }

    paypalData = {
        totalAmount: totalAmount,
        productCode: productCode,
        productName: productName,
        orderId: getLastOrderId(),
        tier: tier,
        hasPaypalPayment: hasPaypalPayment,
        isCCRequiredTrial: isCCRequiredTrial,
        planIsTrial: planIsTrial,
    };

    return paypalData;
};

export const getPageValueForCheckoutABTest = (url) => {
    let page = 'plans', checkoutPageUrl = APP_HASH_PATH.CHECKOUT_PAGE + CHECKOUT_PAGE_TYPE.CHECKOUT_SUMMARY;
    url = url || window.location.href;

    if (isInHub() === false) {
        page = 'website_' + page;
    } else {
        /* istanbul ignore else */
        if (url.indexOf(checkoutPageUrl) !== -1) {
            page = 'checkout_summary';
        }
        page = (shouldViewUpgrade() ? 'upgrade_' : 'website_') + page;
    }

    return page;
};


export const getBranchName = () => {
    let branchName = localStorage.getItem(LOCAL_BRANCH_NAME);
    /* istanbul ignore else */
    if (branchName === null) {
        const scripts = document.getElementsByTagName('script');

        for (let i = 0; i < scripts.length; i++) {
            let src = scripts[i].getAttribute('src');
            if (src && src.indexOf("/branch/") > 0) {
                src = src.substr(src.indexOf("/branch") + 1, src.length - 1);
                src = src.substr(src.indexOf("/") + 1, src.length - 1);
                branchName = src.substr(0, src.indexOf("/"));
                break;
            }
        }
        if (branchName === null) {
            // branch name is still NULL, we set a default value
            branchName = 'local-dev';
        }
        localStorage.setItem(LOCAL_BRANCH_NAME, branchName);
    }

    return branchName;
};

// Shuffle array
export const  shuffleArray = (array) => {
    let currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;
};

export const isExtensionFlow = () => {
    return (window.location.href.indexOf('flow=extension') !== -1 || window.location.href.indexOf('origin=rce') !== -1);
}

export const getChromeExtensionLocationParamValue = () => {
    const flowParams = URLHelper.getUrlParamValueFromWindowObj(window.location, 'flowParameters');
    let flowParamObj;
    if (flowParams) {
        flowParamObj = JSON.parse(atob(flowParams));
    }

    if (flowParamObj.hasOwnProperty('location')) {
        return flowParamObj.location;
    } else {
        return "chrome_recorder";
    }
}

export const getChromeExtensionId = () => {
    switch (process.env.NODE_ENV) {
        case 'development':
            return 'deidfdfkmabijngekobgdenaaohfoofc';
        case 'production':
            return 'deidfdfkmabijngekobgdenaaohfoofc';
        default:
            return 'deidfdfkmabijngekobgdenaaohfoofc';
    }
}
